import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { customFetchDocumentInfo } from "../../../api/custom/documentsApi";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import ToastMessageContainer from "../../../widgets/toastMessageContainer/ToastMessageContainer";
import LoaderWrapper from "../../../widgets/loaderWrapper/LoaderWrapper";
import CustomDocumentViewerImage from "../../../widgets/documents/customDocumentViewerWidgets/CustomDocumentViewerImage";
import CustomDocumentViewerPDF from "../../../widgets/documents/customDocumentViewerWidgets/CustomDocumentViewerPDF";
import CustomDocumentViewerDOCX from "../../../widgets/documents/customDocumentViewerWidgets/CustomDocumentViewerDOCX";

const PDFDocumentViewerExtensions = ['pdf', '.pdf']
const ImageDocumentViewerExtensions = ['jpg', '.jpg', 'jpeg', '.jpeg', 'png', '.png', 'gif', '.gif', 'tiff', '.tiff']
const DOCXDocumentViewerExtensions = ['docx', '.docx']

export default function CustomDocumentViewerPage() {
    const { id, objectType, entityId }: any = useParams()
    const restAuthToken = useAppSelector(state => state.customAuth.customAuthToken)
    const currentConfig = getItemWebStorage('currentConfig')
    const { cardAdditionalItems } = currentConfig
    const cardAdditionalItem = cardAdditionalItems.find((item: any) => item?.id === id)
    const [documentExtension, setDocumentExtension] = useState<any>(null)
    const [documentName, setDocumentName] = useState<any>(null)

    async function getDocumentInfo() {
        const { openDataOptions: restAuthRequestOptions, api, documents } = cardAdditionalItem ?? {}
        const { documentViewer } = documents ?? {}
        const { propertyForExtension, propertyForName } = documentViewer ?? {}
        let { documentInfo: documentInfoApi } = api ?? {}
        let document = await customFetchDocumentInfo(entityId, documentInfoApi, restAuthRequestOptions, restAuthToken)
        if (document) {
            const extension = document?.[propertyForExtension]
            const name = document?.[propertyForName]
            if (extension) setDocumentExtension(extension)
            if (name) setDocumentName(name)
        }
    }

    useEffect(() => {
        if (restAuthToken) {
            getDocumentInfo()
        }
    }, [restAuthToken, objectType])

    const documentIsPDF = PDFDocumentViewerExtensions.includes(documentExtension)
    const documentIsImage = ImageDocumentViewerExtensions.includes(documentExtension)
    const documentIsDOCX = DOCXDocumentViewerExtensions.includes(documentExtension)

    return (
        <>
            <ContentHeader title={documentName} />
            <div className="document-viewer-page-div">
                <ToastMessageContainer />
                <LoaderWrapper isLoading={!documentExtension}>
                    {documentIsPDF &&
                        <CustomDocumentViewerPDF />
                    }
                    {documentIsImage &&
                        <CustomDocumentViewerImage />
                    }
                    {documentIsDOCX &&
                        <CustomDocumentViewerDOCX />
                    }
                </LoaderWrapper>
            </div>
        </>
    )
}
